// @flow
import {default as OpeningHours} from "opening_hours";
import { getLocale } from '../../../helpers/locale';
const currentDate = new Date();
const today = new Date();
today.setHours(0, 0, 0, 0);
const weekDay = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];
const monthSelector = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
/**
 * @private
 */
export type OSMIntervals = {
    day: string | null,
    opensAt: string,
    closesAt: string,
    isSpecial: boolean,
    slots: Array<TimeRange>
}
/**
 * @private
 */
export type TimeRange = {
    time: string,
    isSpecial: boolean
}

/**
 * @private
 */
export default class OSMOpeningHours {
    opening_hours: any;

    constructor(text: string, locale: string = 'fr') {
        try {
            this.opening_hours = new OpeningHours(text, {
                address: {country_code: locale},
            });
        } catch (error) {
            console.warn("Invalid input for opening hours");
            this.opening_hours = undefined;
        }
    }
    getState(): boolean {
        return this.opening_hours.getState();
    }
    getNextChange(): string {
        const nextchange = this.opening_hours.getNextChange(currentDate);
        if (nextchange) {
            const closingAt = new Date(nextchange);
            const closingAtMins = (`0${closingAt.getMinutes()}`).slice(-2);
            return `${closingAt.getHours()}:${closingAtMins}`;
        } else return '';
    }
    getNextChangeDay(): string {
        const nextchange = this.opening_hours.getNextChange(currentDate);
        if (nextchange) {
            const dayNumber = new Date(nextchange).getDay();
            const timeToOpen = new Date(nextchange).getHours() - currentDate.getHours();
            return this.isTomorrow(nextchange) ? getLocale().indoor.tomorrow : timeToOpen < 12 && this.isToday(nextchange)  ? '' : (getLocale().indoor as any)[weekDay[dayNumber]];
        } else return '';
    }
    getNextSlot(threshold: number): Array<OSMIntervals> {
        const from = today;
        const to = new Date(new Date().setDate(new Date().getDate() + threshold));
        const intervals = this.opening_hours.getOpenIntervals(from, to);
        const arrDays: Array<OSMIntervals> = [];
        const regexDays = /0[1-9]|[12]\d|3[01]/;
        for (const count in intervals) {
            const start = intervals[count][0];
            const end = intervals[count][1];
            const iterator = this.opening_hours.getIterator(start);
            const matchingRule = this.opening_hours.prettifyValue({
                rule_index: iterator.getMatchingRule(),
            });
            const appliedRule = iterator.getMatchingRule() ? matchingRule.split(' ', 2) : null;
            let isSpecial: boolean = false;
            for (let index = 0; index < monthSelector.length; index++) {
                const element = monthSelector[index];
                if (appliedRule && appliedRule.length > 0) {
                    const dayFound = appliedRule[1].match(regexDays);
                    if (appliedRule[0].includes(element) && dayFound && dayFound.length > 0) {
                        isSpecial = true;
                        break;
                    }
                }
            }
            const day = weekDay[new Date(start).getDay()];
            const startHours = start.getHours();
            const startMins = (`0${start.getMinutes()}`).slice(-2);
            const endHours = end.getHours();
            const endMins = (`0${end.getMinutes()}`).slice(-2);
            const OSMInterval = {
                day: (getLocale().indoor as any)[day],
                opensAt: `${startHours}:${startMins}`,
                closesAt: `${endHours}:${endMins}`,
                isSpecial,
                slots: []
            };
            arrDays.push(OSMInterval);
        }
        const results = this.groupTimeSlotsDaywise(arrDays);
        if (results.length > 0) {
            const firstDay = results[0].day;
            const lastDay = results[results.length - 1].day;
            if (firstDay === lastDay) {
                results.pop();
            }
        }
        return results;
    }
    groupTimeSlotsDaywise(slots: Array<OSMIntervals>): Array<any> {
        const slotsByDays: any[] = [];
        let prevSlotsByDay = {day: null, slots: []};
        slots.forEach(slot => {
            if (prevSlotsByDay.day !== slot.day) {
                prevSlotsByDay = {day: slot.day, slots: [], isSpecial: slot.isSpecial};
                slotsByDays.push(prevSlotsByDay);
            }
            prevSlotsByDay.slots.push({time: `${slot.opensAt} - ${slot.closesAt}`, isSpecial: slot.isSpecial});
        });
        return slotsByDays;
    }
    isTomorrow (date: Date): boolean {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);

        return date.getDate() === tomorrow.getDate() &&
           date.getMonth() === tomorrow.getMonth() &&
           date.getFullYear() === tomorrow.getFullYear();
    }
    isToday (date: Date): boolean {
        const today = new Date();

        return date.getDate() === today.getDate() &&
           date.getMonth() === today.getMonth() &&
           date.getFullYear() === today.getFullYear();
    }

}

